module.exports = __webpack_public_path__ + "img/paradero-buses.0bae1df5.svg";